'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalRadio_web_styles = require('./InternalRadio.web.styles.cjs');

/**
 * Styled radio element, used for form inputs
 *
 * @scope Core
 *
 */ const InternalRadio = ({ id, hidden = false, disabled = false, children, checked, css, ...rest })=>{
    const labelStyles = [
        InternalRadio_web_styles.radioWrapper,
        hidden && InternalRadio_web_styles.hidden,
        disabled && InternalRadio_web_styles.disabled,
        css
    ];
    const radioCircleStyles = [
        InternalRadio_web_styles.circleContainer.base,
        disabled && InternalRadio_web_styles.circleContainer.disabled
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs("label", {
        css: labelStyles,
        "aria-disabled": disabled,
        "aria-hidden": hidden,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("input", {
                id: id,
                type: "radio",
                checked: checked,
                css: InternalRadio_web_styles.radio,
                disabled: disabled,
                ...rest
            }),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: radioCircleStyles,
                children: /*#__PURE__*/ jsxRuntime.jsx("div", {
                    css: InternalRadio_web_styles.radioInner
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalRadio_web_styles.radioContent,
                children: children
            })
        ]
    });
};

exports.InternalRadio = InternalRadio;
//# sourceMappingURL=InternalRadio.web.cjs.map
